import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import "../../syncCsrfToken";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { ZiggyVue } from "../../../../vendor/tightenco/ziggy/src/js";
import SupportPlugin from "../../Plugins/support";
import ToastProvider from "@/Providers/ToastProvider.vue";
import { setupI18n } from "../../i18n";
import { initSentry } from "../../sentry";

const appName = import.meta.env.VITE_APP_NAME || "Fruitfy";

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `../../Pages/${name}.vue`,
            import.meta.glob([
                "../../Pages/Checkouts/Index.vue",
                "../../Pages/Checkouts/Templates/secondary.vue",
                "../../Pages/Checkouts/PixGenerated.vue",
                "../../Pages/Checkouts/ThankYou/Index.vue",
                "../../Pages/Errors/Custom.vue",
                "../../Pages/Errors/404.vue",
                "../../Pages/Errors/500.vue"
            ])
        ),
    setup: async ({ el, App, props, plugin }) => {
        const app = createApp({
            render: () => h(ToastProvider, {}, () => h(App, props)),
        });

        const i18n = await setupI18n();

        initSentry(app);

        return app
            .use(plugin)
            .use(SupportPlugin)
            .use(i18n)
            .use(ZiggyVue)
            .directive("focus-scroll", {
                mounted(el) {
                    el.addEventListener("focus", () => {
                        setTimeout(() => {
                            el.scrollIntoView({
                                behavior: "smooth",
                                block: "center",
                            });
                        }, 300);
                    });
                },
            })
            .mount(el);
    },
    progress: {
        color: "#0BE0FF",
        height: "100px",
        includeCSS: true,
    },
});
